var actions = ['CART_CHANGED'];
var actionTypes = actions.reduce(function (acc, x) {
  acc[x] = x;
  return acc;
}, {});
export default actionTypes;